import styled from 'styled-components'

export const Empty = styled.div.attrs({
  className: 'empty',
})`
  width: 100%;
`
